<div class="mainLayoutClass"><router-outlet></router-outlet></div>
<app-reusable-footer [footerData]="ioReusableElement"></app-reusable-footer>
